import * as React from 'react';
import { Typography } from '@material-ui/core';
import IconDialog from '../IconDialog/IconDialog';
import { loadingMessage } from '../../utils/loadingMessage';

interface LoaderDialogProps {
  open: boolean;
  children?: string;
}

export const LoaderDialog: React.FC<LoaderDialogProps> = ({ children, open }) => {
  return (
    <IconDialog open={open} icon="loading" rotating>
      <Typography variant="h3" align="center">{children || loadingMessage}</Typography>
    </IconDialog>
  );
};
